import StaffPositionIndexVue from "@/views/staff-position/StaffPositionIndex.vue";

const staffPosition = [
  {
    path: "/staff-position",
    name: "staff-position",
    component: StaffPositionIndexVue,
    meta: {
      layout: "default",
      role: ["superadmin","backoffice","supervisor"],
      public: false,
    },
  },
];

export default staffPosition;
